import http from '@/utils/network/http/axios'
const { REFRESH_TOKEN, MANAGE, COMMON, READ } = process.env

/**
 * 系统公告列表
 * @param {*}
 */
export function noticextList(params) {
  return http.post(`/system/noticextList`, params)
}

/**
 * 系统公告详情
 * @param {*}
 */
 export function noticextDetail(params) {
  return http.post(`/system/noticextDetail`, params)
}

/**
 * 系统公告删除
 * @param {*}
 */
 export function noticextDel(params) {
  return http.post(`/system/noticextDel`, params)
}

/**
 * 系统公告保存
 * @param {*}
 */
 export function noticextAdd(params) {
  return http.post(`/system/noticextAdd`, params)
}

/**
 * 公告、互动详情
 * @param {*}
 */
 export function kstongzhiDetail(params) {
  return http.post(`/system/kstongzhiDetail`, params)
}

/**
 * 信息互动列表
 * @param {*}
 */
 export function kstongzhiList_send(params) {
  return http.post(`/system/kstongzhiList_send`, params)
}

/**
 * 信息互动列表
 * @param {*}
 */
 export function kstongzhiDel(params) {
  return http.post(`/system/kstongzhiDel`, params)
}

/**
 * 留言列表
 * @param {*}
 */
 export function MessageList(params) {
  return http.post(`/system/messageList`, params)
}

/**
 * 留言详情
 * @param {*}
 */
 export function messageDetail(params) {
  return http.post(`/system/messageDetail`, params)
}

/**
 * 留言保存
 * @param {*}
 */
 export function messageAdd(params) {
  return http.post(`/system/messageAdd`, params)
}

/**
 * 回复留言
 * @param {*}
 */
 export function messageReplyAdd(params) {
  return http.post(`/system/messageReplyAdd`, params)
}

/**
 * 删除留言
 * @param {*}
 */
 export function messageDel(params) {
  return http.post(`/system/messageDel`, params)
}

/**
 * 政策法规列表
 * @param {*}
 */
 export function zhengceList(params) {
  return http.post(`/system/zhengceList`, params)
}

/**
 * 删除政策法规
 * @param {*}
 */
 export function zhengceDel(params) {
  return http.post(`/system/zhengceDel`, params)
}

/**
 * 保存政策法规
 * @param {*}
 */
 export function zhengceAdd(params) {
  return http.post(`/system/zhengceAdd`, params)
}

/**
 * 政策法规详情
 * @param {*}
 */
 export function zhengceDetail(params) {
  return http.post(`/system/zhengceDetail`, params)
}

/**
 * 政策法规详情
 * @param {*}
 */
 export function zhengceCateDetail(params) {
  return http.post(`/system/zhengceCateDetail`, params)
}



/**
 * 首页管理菜单列表
 * @param {*}
 */
 export function zhengceCateList(params) {
  return http.post(`/system/zhengceCateList`, params)
}

/**
 * 新增首页管理菜单
 * @param {*}
 */
 export function zhengceCateAdd(params) {
  return http.post(`/system/zhengceCateAdd`, params)
}

/**
 * 首页菜单删除
 * @param {*}
 */
 export function zhengceCateDel(params) {
  return http.post(`/system/zhengceCateDel`, params)
}

/**
 * 获取机构管理要素模块列表
 * @param {*}
 */
 export function getOragan_element(params) {
  return http.post(`/system/getOragan_element`, params)
}

/**
 * 删除机构管理要素模块
 * @param {*}
 */
 export function getOragan_element_DEL(params) {
  return http.post(`/system/getOragan_element_DEL`, params)
}

/**
 * 机构管理模块详情
 * @param {*}
 */
 export function getOragan_element_Detail(params) {
  return http.post(`/system/getOragan_element_Detail`, params)
}

/**
 * 机构管理模块保存
 * @param {*}
 */
 export function getOragan_element_Save(params) {
  return http.post(`/system/getOragan_element_Save`, params)
}

/**
 * 首页展示菜单列表
 * @param {*}
 */
 export function menuIndexshow(params) {
  return http.post(`/system/menuIndexshow`, params)
}

/**
 * 获取监控列表
 * @param {*}
 */
 export function monitorVideoList(params) {
  return http.post(`/system/monitorVideoList`, params)
}

/**
 * 保存监控信息
 * @param {*}
 */
 export function monitorVideoAdd(params) {
  return http.post(`/system/monitorVideoAdd`, params)
}

/**
 * 监控信息删除
 * @param {*}
 */
 export function monitorVideoAddDel(params) {
  return http.post(`/system/monitorVideoAddDel`, params)
}

/**
 * 培训通知新增
 * @param {*}
 */
 export function pxtongzhiAdd(params) {
  return http.post(`/system/pxtongzhiAdd`, params)
}

/**
 * 通知模板
 * @param {*}
 */
 export function kstongzhi_model_Detail(params) {
  return http.post(`/system/kstongzhi_model_Detail`, params)
}

/**
 * 通知模板
 * @param {*}
 */
 export function kstongzhi_model(params) {
  return http.post(`/system/kstongzhi_model`, params)
}

/**
 * 获取未读消息数
 * @param {*}
 */
 export function getUnReadMessageCount(params) {
  return http.post(`/system/getUnReadMessageCount`, params)
}

/**
 * 获取未读消息列表
 * @param {*}
 */
 export function getAllUnReadMessage(params) {
  return http.post(`/system/getAllUnReadMessage`, params)
}

/**
 * 模板-获取机构管理模块列表
 * @param {*}
 */
 export function getOragan_element_model(params) {
  return http.post(`/system/getOragan_element_model`, params)
}

/**
 * 机构管理模块附件删除
 * @param {*}
 */
 export function getOragan_element_file_DEL(params) {
  return http.post(`/system/getOragan_element_file_DEL`, params)
}

/**
 * 模板-机构管理模块模板保存
 * @param {*}
 */
 export function getOragan_element_model_Save(params) {
  return http.post(`/system/getOragan_element_model_Save`, params)
}

/**
 * 模板-模板要素授权
 * @param {*}
 */
 export function getOragan_element_model_grant(params) {
  return http.post(`/system/getOragan_element_model_grant`, params)
}

/**
 * 模板-删除管理模块
 * @param {*}
 */
 export function getOragan_element_model_DEL(params) {
  return http.post(`/system/getOragan_element_model_DEL`, params)
}

/**
 * 获取复训提醒模板
 * @param {*}
 */
 export function getFxTipsTemplate(params) {
  return http.post(`/system/getFxTipsTemplate`, params)
}

/**
 * 保存复训提醒模板
 * @param {*}
 */
 export function saveFxTipsTemplate(params) {
  return http.post(`/system/saveFxTipsTemplate`, params)
}

/**
 * 获取复训消息列表
 * @param {*}
 */
 export function fxTipsList(params) {
  return http.post(`/system/fxTipsList`, params)
}
